const tr = {
  accidentReports: {
    attributes: {
      id: 'ID Consulta',
      name: 'Nome',
      cpf: 'CPF',
      specialty: 'Especialidade',
      doctor_init_at: 'Início Consulta',
      doctor_end_at: 'Fim Consulta',
      corporation: 'Empresa',
      created_At: 'Data Cadastro',
      pacient: 'Paciente',
      owner: 'Titular',
      policy_number: 'Nº Seguro',
      user_corporation_name: 'Empresa',
    },
    extras: {
      date_init: 'Data inicial',
      date_end: 'Data final',
      search: 'Digite o nome ou CPF',
      considerBranches: 'Considerar filiais',
      considerAllBranches: 'Considerar todas filiais',
      consider: 'Considerar',
      pack: 'Adicional',
      specialtie: 'Especialidade',
    },
    defSingular: 'Relatório de adicionais ativos por empresa',
  },
};

export default tr;
